import React, { ReactNode } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Button } from 'src/components/Button';

import './PageSidebar.scss';
import ArrowIcon from 'src/assets/layout/navigation/arrow.svg';

interface PageSidebarProps {
  backLink?: string;
  children?: ReactNode | ReactNode[];
  clickFn?: () => void;
}

export const PageSidebar: React.FC<PageSidebarProps> = ({ children, backLink = '#', clickFn }) => {
  const history = useHistory();

  const goToLink = () => {
    history.push(backLink);
  };

  const execFunc = () => {
    if (clickFn) {
      clickFn?.();
    } else {
      goToLink();
    }
  };

  return (
    <div className="app-page-sidebar">
      <div className="app-page-sidebar__sticky">
        {backLink && (
          <div className="app-page-sidebar__back">
            <Button
              title="Back"
              icon={ArrowIcon}
              className="button-back"
              onClick={() => {
                execFunc();
              }}
            />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
